module.exports = __webpack_public_path__ + "img/Spain.cf7bd934.png";